import { CITIES } from "./cities";

export const SELECTED_CITY_STORAGE_KEY = "fevicolInhomzSelectedCityId";

export function getStoredCityId() {
  try {
    const stored = localStorage.getItem(SELECTED_CITY_STORAGE_KEY);
    return CITIES.some((city) => city.id === stored) ? stored : null;
  } catch {
    return null;
  }
}
